import { useFieldArray, useFormContext } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import PartnerItem from "./partnerItem/PartnerItem";
import { getPrincipalModel } from "./principals/Principals";

export const getPartnerModel = () => ({
  address: "",
  biography: "",
  corporate_net_asset_value: "",
  corporation_name: "",
  fullname: "",
  guarantor_status: "",
  hq_address: "",
  identification: "",
  industry: "",
  number_of_lp_units: null,
  partner_type: "person",
  partnership_type: "",
  personal_net_worth: "",
  website: "",
  entity_type: "person",
  share_percentage: "",
  principals: [getPrincipalModel()],
  corporate_share_register_filename: null,
  financial_statement_filename: null,
  incorporation_document_filename: null,
  net_worth_document_filename: null,
});

const Partners = ({ type, opportunityId }) => {
  const form = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "partners",
  });

  const addPartner = () => {
    append({
      key: uuidv4(),
      ...{ ...getPartnerModel(), opportunity_id: opportunityId },
    });
  };

  return (
    <div className={"px-3"}>
      {fields.map((item, index) => (
        <PartnerItem
          type={type}
          key={item.id || item.key}
          index={index}
          onDelete={() => remove(index)}
        />
      ))}
      <div
        className={"fw-bold text-primary my-3 d-inline-block"}
        role={"button"}
        onClick={addPartner}
      >
        + Add one more Partner
      </div>
    </div>
  );
};

export default Partners;
